<template>
  <vs-card>
    <vs-table
      @search="handleSearch"
      @sort="handleSort"
      :total="totalItems"
      max-items="10"
      search
      :data="teamMembers"
    >
      <template slot="thead">
        <vs-th sort-key="photo">{{$t('Profile.Photo')}}</vs-th>
        <vs-th sort-key="fname">{{$t('Profile.FirstName')}}</vs-th>
        <vs-th sort-key="email">{{$t('Profile.Email')}}</vs-th>
        <vs-th sort-key="position">{{$t('Profile.Role')}}</vs-th>
       
        <vs-th>{{$t('Team.Options')}}</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].fname">
            <div class="d-flex align-items-center text-center">
              <vs-avatar
                class
                :src="data[indextr].photo ? data[indextr].photo : require('@/assets/images/users/1.jpg')"
                size="42px"
              ></vs-avatar>
            </div>
          </vs-td>

          <vs-td :data="data[indextr].name">
            <div class="d-flex align-items-center">
              <h5 class="mb-0 font-12">{{data[indextr].name}}</h5>
            </div>
          </vs-td>

          <vs-td :data="data[indextr].email">
            <div class="d-flex align-items-center">
              <span class>{{data[indextr].email}}</span>
            </div>
          </vs-td>

          <vs-td :data="data[indextr].role">
            <div class="d-flex align-items-center">
              <span
                class
              >{{$t('Team.Positions.'+(data[indextr].role.charAt(0).toUpperCase() + data[indextr].role.toLowerCase().slice(1)))}}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="btn-alignment">
              
              <vs-button
                radius
                color="warning"
                type="border"
                id="edit-team-button"
                icon="edit"
                @click="editPromptMember(data[indextr])"
              ></vs-button>
              <vs-button
                radius
                color="danger"
                type="border"
                icon="delete"
                @click="deletePromptMember((data[indextr].id))"
              ></vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div>
      <!-- edit membre -->
      <vs-prompt
        activeUpdatePrompt
        color="warning"
        @accept="updateTeamMember"
        @close="close"
        @cancel="close"
        :active.sync="activeUpdatePrompt"
        :title="$t('Team.EditTeamMemberPrompt.Title')"
        :accept-text="$t('Team.EditTeamMemberPrompt.SubmitButton')"
        :cancel-text="$t('Team.EditTeamMemberPrompt.CancelButton')"
      >
        <div>
          <div v-bar class="vs-scrollable">
            <div>
              <div class="con-exemple-prompt px-4 py-3">
                <vs-row>
                  <vs-col vs-w="6">
                    <vs-input
                      :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.LastName')})"
                      :label="$t('Profile.LastName')"
                      v-model="selected.name"
                      class="w-100 mb-2"
                    />
                  </vs-col>
                </vs-row>

                <vs-input
                  :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.Email')})"
                  :label="$t('Profile.Email')"
                  v-model="selected.email"
                  class="w-100 mb-2"
                />


                <vs-select
                  class="w-100 mb-2"
                  :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.Role')})"
                  :label="$t('Profile.packages')"
                  v-model="selected.role"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item,index) in positions"
                  />
                </vs-select>

                <vs-select
                  class="w-100 mb-2"
                  :label="$t('Profile.Department')"
                  v-if="departments.length"
                  v-model="selected.department_id"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item,index) in departments"
                  />
                </vs-select>

                <vs-row>
                  <vs-col vs-w="3">
                    <vs-avatar
                      class="mt-3"
                      :src="selected.photo ? selected.photo : require('@/assets/images/users/1.jpg')"
                      size="64px"
                    ></vs-avatar>
                  </vs-col>
                </vs-row>
              </div>
            </div>
          </div>
        </div>
      </vs-prompt>
      <!-- CONFIRM DIALOG PROMPT -->
       
      <div class="centerx con-exemple-prompt">
        <vs-prompt @accept="deleteMember(selected.id)" color="danger" @close="Closed" :active.sync="activePrompt">
          <div class="con-exemple-prompt">
            Are you sure to delete
            {{selected.name}}
            account ?
          </div>
        </vs-prompt> 
      </div>
      <!-- END OF edit membre -->
    </div>
  </vs-card>
</template>
<script>
import { teamService } from "../../_services";
import edit from "../../components/Team/edit";
import router from"../../_helpers/router.js";
export default {
  name: "TeamMemberTable",
  data: () => ({
    title: "TeamMemberTable",
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    business:[],
    accounts:[],
    activeUpdatePrompt: false,
    activepromptconfirm: false,
    activePrompt: false,
    selected: {},
    positions: [],
    departments: [],
    errors: {
      fname: false,
      lname: false,
      telephone: false,
      email: false,
      password: false,
      password_confirm: false,
      role: false,
     
    }
  }),
  props: {
    teamMembers: Array
  },
  methods: {
    close() {
      this.fname = "";
      this.lname = "";
      this.telephone = "";
      this.email = "";
      this.password = "";
      this.password_confirm = "";
      this.role = "";
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text
      });
    },
     show(item){
this.$router.push('/showmember/'+item);


    },
    Closed() {
      this.$vs.notify({
        color: "danger",
        title: "Delete Cancel",
        text: "Cancelling!"
      });
    },
    getAllTeamMember(){
teamService.getAll().then(function(data){
this.business=data.business.data;
this.accounts=data.accounts.data;
console.log(data);

})},
    updateTeamMember() {
let self=this;
      teamService.update(this.selected).then(function(data) {
         self.$vs.notify({title: 'success',text: 'account successfully updated', position: 
         'bottom-right', type: 'success' ,color:'green' });
        router.go();
        console.log(data);
        console.log("updated account ");
      });
      this.activeUpdatePrompt = false;
    },

    deleteMember(id) {
       let self = this;
      teamService
        .deleteTeamMember(id)
        .then(function(data) {
          console.log(data);
      self.$vs.notify({title: 'succes delete',text: 'account successfully deleted', position: 
         'bottom-right', type: 'success' ,color:'green' });
         router.go();
          console.log(data);
        })
        .bind(this);
         
      this.activePrompt = false;
      this.selected = null;
     // this.$router.push('/settings/team');
  
    },
    editPromptMember(item) {
      this.selected = {
        id:item.id,
        name:item.name,
        email:item.email


      }
      console.log(this.selected);
      this.activeUpdatePrompt = true;
      console.log(this.activeUpdatePrompt);
    },

    deletePromptMember(item) {
      this.selected.id = item;
      this.activePrompt = true;
    },
    handleChangePage(page) {
      teamService.getPage(page).then(function (data) {
        console.log(data);
        this.accounts = data.accounts.data;
      }.bind(this)).finally(function () {
      }.bind(this));
    },
    handleSelected() {
      /* eslint-disable */
      console.log("test");
      console.log(this.selected);
    },
    handleSearch(keyword) {
      if (keyword == "") {
        // teamService.getAll().then(function (data) {
        //   this.teamMembers = data.team.data;
        //   this.totalItems = data.team.total;
        //   this.totalPages = data.team.last_page;
        //   this.maxItems = data.team.per_page;
        // }.bind(this));
      }
      //   teamService.filter(keyword).then(function (data) {
      //     this.teamMembers = data.team.data;
      //     this.totalItems = data.team.total;
      //   }.bind(this));
    },
    handleSort(key, active) {
      /* eslint-disable */
      console.log({ key, active });
    },
    showLoading() {
      this.$vs.loading({
        container: "#queue-box",
        scale: 0.6
      });
    },
    hideLoading() {
      this.$vs.loading.close("#queue-box > .con-vs-loading");
    }
  },
  computed: {},
  mounted() {
teamService.getAll().then(function(data){
      console.log(data);

    this.accounts=data.accounts.data;
this.totalItems = data.accounts.total;
console.log("total item"+this.totalItems);
      this.maxItems = data.accounts.per_page;
      console.log("max items"+this.maxItems);

      this.totalPages = data.accounts.last_page;
            console.log("totals pages"+this.last_page);



    }.bind(this));
  },
  components: {
    edit
  }
};
</script>
<style lang="stylus" scoped>

</style>